import { Component, HostListener, OnInit, Optional, inject } from '@angular/core';
import { ModalOptionsConfig, ModalService } from '../../../lean-shared/components/nz-modal-service/modal.service';
import { UserPinSetupModalComponent } from '../../../lean-shared/components/user-pin-setup-modal/user-pin-setup-modal.component';
import { AppConfig } from '../../config/app-config';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';
import { DialogMessageType } from '../../models/utility.model';

@Component({
  selector: 'app-plain-result-modal',
  templateUrl: './plain-result-modal.component.html',
  styleUrls: ['./plain-result-modal.component.scss']
})
export class PlainResultModalComponent implements OnInit {

  details;
  currentModal;
  readonly success = 1;
  readonly failure = 2;
  readonly pending = 3;
  readonly DEFAULT_MOBILE_BREAKPOINT = 768;
  modalTitle = "";
  modalBody = "";
  btnText = "";
  secondaryButtonText = "";
  useFailureSecondaryButton = false;
  isMobile;
  messageType: DialogMessageType;
	runningModal: NzModalRef;
  readonly nzModalData = inject(NZ_MODAL_DATA, { optional: true }) ?? {};

  constructor(
    @Optional() public modalService: NzModalRef,
		private modal: ModalService,
		private config: AppConfig
  ) {
	}

	ngOnInit(): void {
    this.modalService.componentInstance = { ...this.modalService.componentInstance, ...this.nzModalData };
		this.details = this.modalService?.componentInstance?.data;
    this.modalBody = this.details.modalBody;
    this.setMobile(window.innerWidth);
    this.messageType  = this.details.messageType;
    this.btnText = this.details.btnText || "Close";
    this.modalTitle = this.details.modalTitle;
    this.useFailureSecondaryButton = this.details?.useFailureSecondaryButton;
    this.secondaryButtonText = this.details?.secondaryButtonText;
    this.currentModal = this.messageType ===  DialogMessageType.SUCCESS ? this.success: this.messageType === DialogMessageType.PENDING ? this.pending : this.failure;
    this.checkUserPinFailure();
	}

  checkUserPinFailure() {
    const noUserPinMessage = 'Authorization pin not set, kindly set one to proceed.';
    if (this.modalBody === 'Invalid Authorisation PIN, enter a valid PIN or reset your PIN') {
      this.modalBody = noUserPinMessage;
    }
    if (this.config.SHOW_USER_PIN_MENU && this.modalBody === noUserPinMessage) {
      this.useFailureSecondaryButton = true;
      this.secondaryButtonText = "Set User Pin";
    }
  }

	cancelModal() {
    const state = this.messageType ===  DialogMessageType.SUCCESS ? 'SUCCESS': this.messageType === DialogMessageType.PENDING ? 'PENDING' : 'FAILURE';
    const componentInstance = this.modalService?.componentInstance;
    if(componentInstance?.callback) {
      componentInstance?.callback(state)
    }
		this.modalService.destroy();
	}

  @HostListener('window:resize', ['$event'])
  onResize(_event): void {
    this.setMobile(window.innerWidth);
  }

  setMobile(browserWidth: number) {
    this.isMobile = this.details.isMobile || browserWidth <= this.DEFAULT_MOBILE_BREAKPOINT;
  }

  secondaryAction(){
    this.modalService.destroy();
    this.launchUserPinSetUpModal();
  }

  launchUserPinSetUpModal() {
		const config = new ModalOptionsConfig();
		config.nzMaskClosable = true;
		this.runningModal = this.modal.createModal(
			UserPinSetupModalComponent,
			config
		);
	}

}
